import type { IAdminClaim } from '@/services/admin';

const CSV_COLUMNS: { header: string; value: (claim: IAdminClaim) => string }[] = [
  { header: 'Claim ID', value: (c) => c.id },
  { header: 'Note', value: (c) => c.details },
  { header: 'X-Teamer', value: (c) => c.userName || c.userEmail },
  { header: 'User Email', value: (c) => c.userEmail },
  { header: 'User Group', value: (c) => c.userType ?? '' },
  { header: 'Category', value: (c) => c.categoryName },
  { header: 'Amount', value: (c) => c.amount.toFixed(2) },
  { header: 'Status', value: (c) => c.status },
  { header: 'Date', value: (c) => (c.createdAt ? c.createdAt.slice(0, 10) : '') },
];

/** Quote a CSV field per RFC 4180 whenever it contains a comma, quote, or newline. */
function escapeCsvField(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function claimsToCsv(claims: IAdminClaim[]): string {
  const header = CSV_COLUMNS.map((col) => escapeCsvField(col.header)).join(',');
  const rows = claims.map((claim) =>
    CSV_COLUMNS.map((col) => escapeCsvField(col.value(claim))).join(','),
  );
  return [header, ...rows].join('\r\n');
}

export function downloadCsv(filename: string, csvContent: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
